// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file call/call_model.proto.
 */
export const file_call_call_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChVjYWxsL2NhbGxfbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0Ij8KD0NhbGxQYXJ0aWNpcGFudCIsCgRSb2xlEg0KCVNVUEVSVVNFUhAAEgoKBk1FTUJFUhABEgkKBUdVRVNUEAIibQoSSW5pdGlhbFBhcnRpY2lwYW50Eg8KB3VzZXJfaWQYASABKAMSPQoEcm9sZRgCIAEoDjIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGxQYXJ0aWNpcGFudC5Sb2xlSACIAQFCBwoFX3JvbGVCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.CallParticipant
 */
export type CallParticipant = Message<'com.gem.bff.contract.CallParticipant'> & {};

/**
 * Describes the message com.gem.bff.contract.CallParticipant.
 * Use `create(CallParticipantSchema)` to create a new message.
 */
export const CallParticipantSchema: GenMessage<CallParticipant> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 0);

/**
 * @generated from enum com.gem.bff.contract.CallParticipant.Role
 */
export enum CallParticipant_Role {
  /**
   * @generated from enum value: SUPERUSER = 0;
   */
  SUPERUSER = 0,

  /**
   * @generated from enum value: MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: GUEST = 2;
   */
  GUEST = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallParticipant.Role.
 */
export const CallParticipant_RoleSchema: GenEnum<CallParticipant_Role> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0, 0);

/**
 * @generated from message com.gem.bff.contract.InitialParticipant
 */
export type InitialParticipant = Message<'com.gem.bff.contract.InitialParticipant'> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: optional com.gem.bff.contract.CallParticipant.Role role = 2;
   */
  role?: CallParticipant_Role;
};

/**
 * Describes the message com.gem.bff.contract.InitialParticipant.
 * Use `create(InitialParticipantSchema)` to create a new message.
 */
export const InitialParticipantSchema: GenMessage<InitialParticipant> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 1);
